import { useCallback } from "react";
import { DatePickerProps } from "@progress/kendo-react-dateinputs";
import { kendoDefaultDateFormatddMMyyyy, placeholderDateFormat } from "../Utils/dates";

export const useDefaultDatePickerProps = () =>
  useCallback(
    (props: DatePickerProps) => ({
      ...props,
      format: kendoDefaultDateFormatddMMyyyy,
      formatPlaceholder: {
        day: placeholderDateFormat.day,
        month: placeholderDateFormat.month,
        year: placeholderDateFormat.year,
      },
    }),
    []
  );
